import React from 'react';
import Layout from '../components/Layout';
import Landing from '../sections/Landing';
import Services from '../sections/Services';
import AboutMe from '../sections/AboutMe';
import Projects from '../sections/Projects';
import Header from '../components/Header';
import Contact from '../sections/Contact';
import Footer from '../components/Footer';

const IndexPage = () => (
  <Layout>
    <Header />
    <Landing />
    <Services />
    <Projects />
    <AboutMe />
    <Contact />
    <Footer />
  </Layout>
);

export default IndexPage;
